import { Component, OnInit } from '@angular/core';
import MarketWatchListItem, {
  MarketWatchService,
} from '../../services/market-watch-service';
import { RegistrationService } from '../../services/registration-service';

@Component({
  selector: 'pla-landing-market-watch',
  templateUrl: './landing-market-watch.component.html',
  styleUrls: ['./landing-market-watch.component.scss'],
})
export class LandingMarketWatchComponent implements OnInit {
  public topThisYear: MarketWatchListItem[] = [];
  /** Year shown in the section title; matches the data returned by the API. */
  public displayYear: number = new Date().getFullYear();
  /** true while waiting for API */
  public loading = true;
  /** set if API request failed (so we can show a message) */
  public loadError: string | null = null;

  constructor(
    private marketWatchService: MarketWatchService,
    private registrationService: RegistrationService
  ) {}

  ngOnInit(): void {
    this.FetchMarketWatchData();
  }

  private FetchMarketWatchData(): void {
    const currentYear = new Date().getFullYear();
    this.loading = true;
    this.loadError = null;
    this.topThisYear = [];
    this.displayYear = currentYear;
    // Prefer current year first so "Top Auction Results of 2026" (etc.); fall back to previous year if no data yet
    const prevYear = currentYear - 1;
    this.marketWatchService.GetTopSoldThiYear((res: MarketWatchListItem[] | null) => {
      if (res === null) {
        this.loading = false;
        this.loadError = 'Unable to load auction results.';
        return;
      }
      if (res.length > 0) {
        this.displayYear = currentYear;
        this.setResults(res);
        this.loading = false;
        this.loadError = null;
        return;
      }
      // Current year empty – try previous year
      this.marketWatchService.GetTopSoldThiYear((prevRes: MarketWatchListItem[] | null) => {
        this.loading = false;
        if (prevRes === null) {
          this.loadError = 'Unable to load auction results.';
          return;
        }
        this.loadError = null;
        if (prevRes.length > 0) {
          this.displayYear = prevYear;
          this.setResults(prevRes);
        } else {
          this.setResults([]);
        }
      }, prevYear);
    }, currentYear);
  }

  private setResults(res: MarketWatchListItem[]): void {
    this.topThisYear = res.map((row) => {
      const rawReg = (row.registration || '').trim().replace(/\s+/g, '');
      // One formatted value for all viewports (mobile and desktop) so spacing is consistent.
      const formatted = rawReg
        ? this.registrationService.LocalFormatRegistration(rawReg)
        : (row.formattedRegistration || row.registration || '');
      return {
        ...row,
        formattedRegistration: formatted,
        sold_price: typeof row.sold_price === 'string' ? row.sold_price : String(row.sold_price ?? 0),
        sold_date: row.sold_date ? new Date(row.sold_date as unknown as string | number) : new Date(),
      };
    });
    // Keep displayYear as the year we requested (set in FetchMarketWatchData). Do not overwrite with
    // the first result's sold_date year — results are ordered by price, so the first row can be
    // from a different year (e.g. 2025) and would wrongly change the title to "2025".
  }

  public SellerNameMapper(
    sellerName: string,
    removeAuctionCode: boolean = false
  ): string {
    if (sellerName.startsWith('DVLA AUCTION')) {
      if (removeAuctionCode) return 'DVLA Auction';
      else return sellerName.replace('DVLA AUCTION', 'DVLA Auction');
    }

    if (sellerName.startsWith('CC')) {
      return 'Collecting Cars';
    }

    return sellerName;
  }
}
